<template>
    <DialogueBox :blur="true" :height="638" :width="731" :top="95" :left="294" :rightPadding="64">

        <div class="inner-container">

            <div class="build-a-stopbank" v-html="titleText"></div>
            <div class="intro-text">
                <div v-html="introText"></div>
                <div v-if="CanVote == false" v-html="'<br>' + T('cant_vote_yes')"></div>
            </div>

            <div class="icon-container">

                <div class="icon-group">
                    <div class="icon icon-bank-balance"></div>
                    <div class="icon-header" v-html="T('label_bank_balance')"></div>
                    <div class="icon-value" v-html="roundedValue(bankBalance)"></div>
                </div>

                <div class="icon-group">
                    <div class="icon">
                        <AvatarCircle :size="50" :sizeInner="40" :id="myUser._id" :isSelected="false"
                            :selectable="false" :isReserved="false">
                        </AvatarCircle>
                    </div>
                    <div class="icon-header" v-html="T('your_contribution')"></div>
                    <div class="icon-value" v-html="roundedValue(Cost)"></div>
                </div>

                <div class="icon-group" v-if="GovernmentContribution">
                    <div class="icon icon-government"></div>
                    <div class="icon-header" v-html="T('government_contribution')"></div>
                    <div class="icon-value" v-html="roundedValue(GovernmentContribution)"></div>
                </div>

            </div>

            <div class="button-container">
                <div class="btn-base yes-button" :class="{ 'can-vote': CanVote }" @click="$emit('on-vote', true)">
                    <div v-html="T('button_voteyes')"></div>
                </div>
                <div class="btn-base no-button" @click="$emit('on-vote', false)">
                    <div v-html="T('button_voteno')"></div>
                </div>
            </div>

        </div>

        <div class="facilitator"></div>
        <div class="facilitator-tick"> </div>

    </DialogueBox>

</template>

<script lang="ts">
import { roundedValue, T } from '@/App.vue';
import Vue, { PropType } from 'vue';
import DialogueBox from "./DialogueBox.vue";
import AvatarCircle from './AvatarCircle.vue';
import room_user from '../../../shared_fca/room_user';
import Game from '../../../shared_fca/game';
import playerState from '../../../shared_fca/playerstate';

export default Vue.extend({
    name: 'DialogueStopBankVote',
    components: {
        DialogueBox,
        AvatarCircle,
    },
    props: {
        Cost: Number,
        GovernmentContribution: Number,
        CanVote: Boolean,
        NatureBasedVote: Boolean,
        bankBalance: Number,

        stopBankVoteType: Number,
        natureBasedVoteType: Boolean,

        myUser: Object as PropType<room_user>,
        game: Object as PropType<Game>,
        playerState: Object as PropType<playerState>

    },
    computed: {
        titleText: {
            cache: false,
            get(): string {

                if (this.NatureBasedVote) {

                    //Sea vote
                    if (this.natureBasedVoteType) {
                        return T('Build_naturebased_sea_poll_title');
                    }

                    return T('Build_naturebased_poll_title');
                }

                switch (this.stopBankVoteType) {
                    case 2:
                        return T('Build_seawall_poll_title_2');

                    case 1:
                        return T('Build_seawall_poll_title_1');

                    default:
                        return T('Build_stopbank_poll_title');
                }
            }
        },
        introText: {
            cache: false,
            get(): string {

                if (this.NatureBasedVote) {

                    //Sea vote
                    if (this.natureBasedVoteType) {
                        if (this.game.governmentSubsidy) {
                            if (this.playerState.seaWallHeight > 0) {
                                return T("Build_naturebased_sea_poll_intro_gvt_seawall").replace("###", this.Cost.toString());
                            }
                            return T("Build_naturebased_sea_poll_intro_gvt").replace("###", this.Cost.toString());
                        }

                        //Do we already have a seawall?
                        if (this.playerState.seaWallHeight > 0) {
                            return T("Build_naturebased_sea_poll_intro_seawall").replace("###", this.Cost.toString());
                        }
                        return T("Build_naturebased_sea_poll_intro").replace("###", this.Cost.toString());
                    }

                    if (this.game.governmentSubsidy) {
                        return T("Build_naturebased_poll_intro_gvt").replace("###", this.Cost.toString());
                    }
                    return T("Build_naturebased_poll_intro").replace("###", this.Cost.toString());

                }

                switch (this.stopBankVoteType) {

                    case 2:

                        if (this.game.governmentSubsidy) {
                            if (this.playerState.natureBasedSeaSolution) {
                                return T("Build_seawall_poll_intro_2_gvt_nature").replace("###", this.Cost.toString());

                            }
                            return T("Build_seawall_poll_intro_2_gvt").replace("###", this.Cost.toString());
                        }

                        if (this.playerState.natureBasedSeaSolution) {
                            return T("Build_seawall_poll_intro_2_nature").replace("###", this.Cost.toString());
                        }

                        return T("Build_seawall_poll_intro_2").replace("###", this.Cost.toString());

                    case 1:

                        if (this.game.governmentSubsidy) {
                            if (this.playerState.natureBasedSeaSolution) {
                                return T("Build_seawall_poll_intro_1_gvt_nature").replace("###", this.Cost.toString());

                            }
                            return T("Build_seawall_poll_intro_1_gvt").replace("###", this.Cost.toString());
                        }

                        if (this.playerState.natureBasedSeaSolution) {
                            return T("Build_seawall_poll_intro_1_nature").replace("###", this.Cost.toString());
                        }

                        return T("Build_seawall_poll_intro_1").replace("###", this.Cost.toString());

                    default:
                        return T("Build_stopbank_poll_intro").replace("###", this.Cost.toString());
                }

            }
        }
    },
    methods: {
        roundedValue(value: number): string {
            return roundedValue(value);
        },
        T(value: string): string {
            return T(value);
        }
    }
});
</script>

<style scoped lang="less">
.facilitator {
    width: 270px;
    height: 344.54px;
    top: 247.38px;
    left: -198px;
    position: absolute;
    z-index: -1;
}

.facilitator-tick {
    top: 257px;
    left: -33px;
    rotate: -90deg;
}


.icon-container {
    width: 100%;
    margin-top: 32px;
    display: flex;
    flex-direction: row;
}

.icon-group {
    width: 186px;
    height: 50px;
    margin-right: 14px;
    position: relative;
    display: flex;
}

.icon {
    width: 50px;
    height: 50px;
    background-size: cover;
}


.icon-header {
    width: 155px;
    height: 9px;
    top: 9px;
    left: 63px;
    position: absolute;
    font-family: Rubik;
    font-size: 10px;
    font-weight: 800;
    line-height: 11.85px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
}

.icon-value {
    width: 90px;
    height: 28px;
    top: 21px;
    left: 63px;
    position: absolute;
    color: #636252;
    font-family: Rubik;
    font-size: 18px;
    font-weight: 800;
    line-height: 21.33px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.inner-container {
    font-family: Rubik;
    font-size: 16px;
    font-weight: 400;
    line-height: 18.96px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #333333;
    position: absolute;
    bottom: 0px;
    left: 60px;
    right: 60px;
    top: 80px;
}

.can-vote {
    pointer-events: auto !important;
    opacity: 1 !important;
}

.build-a-stopbank {
    font-family: Rubik;
    font-size: 30px;
    font-weight: 800;
    line-height: 35.55px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    color: #636252;
}

.intro-text {
    margin-top: 41px;
}


.yes-button {
    width: 162px;
    height: 50px;
    border-radius: 8px;
    background-color: #B2CD30;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    opacity: 0.5;
    pointer-events: none;
}

.no-button {
    margin-left: 24px;
    width: 162px;
    height: 50px;
    border-radius: 8px;
    background-color: #F1A738;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 14px;
    font-weight: 800;
    line-height: 16.59px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
}

.button-container {
    width: 100%;
    height: 100%;
    margin-top: 32px;
    display: flex;
}
</style>
